export const BASIC = 'basic';
export const STANDARD = 'standard';
export const PREMIUM = 'premium';
export const ENTERPRISE = 'enterprise';



// WEBPACK FOOTER //
// ./library/app/data/planTypes.js